export const EMOJI_SIZE_MEDIUM = 40;
export const EMOJI_SIZE_LARGE = 80;
